import './App.css';

import { TodoWrapperLocalStorage } from './component/TodoWrapperLocalStorage';

function App() {
  return (
    <div className="App">
      <TodoWrapperLocalStorage  />
    </div>
  );
}

export default App;